import PropTypes from "prop-types";
import styles from "./Button.module.css";
import { COLORS } from "../../../assets/color";

const FormButton = ({
  width,
  label,
  onClick,
  disabled,
  bgColor,
  borderCOlor,
  textCOlor,
  type = "submit",
}) => {

  return (
    <>
      {width === "full" ? (
        <div className={styles.button_container}>
          <button
            style={{ color: textCOlor ? textCOlor : COLORS.white }}
            type={type}
            disabled={disabled}
            className={styles.button_full}
            onClick={onClick}
          >
            <span className={styles.button_text}>{label}</span>
          </button>
        </div>
      ) : width === "medium" ? (
        <div className={styles.button_container}>
          <button
            style={{ color: textCOlor ? textCOlor : COLORS.white }}
            type={type}
            disabled={disabled}
            className={styles.button_medium}
            onClick={onClick}
          >
            <span className={styles.button_text}>{label}</span>
          </button>
        </div>
      ) : (
        width === "small" && (
          <div className={styles.button_container}>
            <button
              style={{ color: textCOlor ? textCOlor : COLORS.white }}
              type={type}
              disabled={disabled}
              className={styles.button_small}
              onClick={onClick}
            >
              <span className={styles.button_text}>{label}</span>
            </button>
          </div>
        )
      )}
    </>
  );
};

export default FormButton;

FormButton.prototype = {
  width: "full" | "medium" | "small",
  label: PropTypes.any,
  onClick: PropTypes.any,
  disabled: PropTypes.boolean,
  bgColor: PropTypes.string,
  textCOlor: PropTypes.string,
  borderCOlor: PropTypes.string,
  type: PropTypes.string,
};
